import React from 'react';
import factory from 'components/Icons/factory';

export const Bookmark = factory(
  'Bookmark',
  <path d="M29 8v112l35-28.9L99 120V8H29z" />
);

export default Bookmark;
